import { useState } from 'react'
import { useShowDialog } from 'App'
import type { Instance } from 'mobx-state-tree'
import type { CenterSummaryModel } from 'models/CenterSettings/CenterModel'
import { PrimaryButton, SecondaryButton } from '../Button/Button'
import { Select, type SelectOption } from '../Select/Select'
import { Column, Row } from '../Table/Table'
import { BodyText, Heading1 } from '../Typography/Typography'

interface TransferVehicleContentProps {
    vehicleId: number
    vehicleName: string
    centerOptions: Array<SelectOption>
    selection: { deploymentId: number | null }
    onConfirmed: VoidFunction
    onCancelled: VoidFunction
}

const TransferVehicleContent = ({ vehicleId, vehicleName, centerOptions, selection, onConfirmed, onCancelled }: TransferVehicleContentProps) => {
    const [selectedOptions, setSelectedOptions] = useState<Array<SelectOption>>([])
    const showDialog = useShowDialog()

    const hideDialog = () => { showDialog(null) }

    return (
        <Column style={{ alignItems: 'center', gap: '1.5em', width: '100%', wordBreak: 'break-word'}}>
            <Heading1>TRANSFER VEHICLE</Heading1>
            <BodyText style={{ textAlign: 'center' }}>choose destination center for vehicle {vehicleName} ({vehicleId}):</BodyText>
            <Select {...{
                name: 'center',
                options: centerOptions,
                selectedOptions,
                label: 'Select center',
                style: { width: '100%' },
                onChange: (e: React.ChangeEvent<HTMLSelectElement>) => {
                    const value = e.target.value
                    selection.deploymentId = Number(value)
                    setSelectedOptions(centerOptions.filter(o => o.value === value))
                },
            }} />
            <Row style={{ marginTop: '1em', gap: '3em' }}>
                <SecondaryButton {...{
                    text: 'Cancel',
                    style: { minInlineSize: '150px' },
                    onClick: () => { hideDialog(); onCancelled() },
                }} />
                <PrimaryButton {...{
                    text: 'Transfer',
                    style: { minInlineSize: '150px' },
                    onClick: () => { hideDialog(); onConfirmed() },
                }} />
            </Row>
        </Column>
    )
}

interface ShowTransferVehicleDialogParams {
    showDialog: ReturnType<typeof useShowDialog>
    vehicleId: number
    vehicleName: string
    vehicleDeploymentId: number
    centers: Array<Instance<typeof CenterSummaryModel>>
    assignToDeployment: (vehicleId: number, centerId: number) => Promise<void>
}

export function showTransferVehicleDialog({ showDialog, vehicleId, vehicleName, vehicleDeploymentId: vehicleCenterId, centers, assignToDeployment: assignToDeployment }: ShowTransferVehicleDialogParams) {
    const selection = { deploymentId: null as number | null }

    const centerOptions: Array<SelectOption> = centers.filter(c => c.id !== vehicleCenterId).map(c => ({
        value: c.id.toString(),
        text: `${c.id} - ${c.name}`,
    }))

    showDialog({
        content: (
            <TransferVehicleContent
                vehicleId={vehicleId}
                vehicleName={vehicleName}
                centerOptions={centerOptions}
                selection={selection}
                onCancelled={() => {}}
                onConfirmed={() => {
                    if (selection.deploymentId !== null) {
                        void assignToDeployment(vehicleId, selection.deploymentId)
                    }
                }}
            />
        ),
    })
}
